import RequestBase from './RequestBase';

export default class CreateAccountRequest extends RequestBase {
    constructor(customerId, accountTypeId) {
        super();
        this._url = '/Accounts';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'customerId',
            'accountTypeId'
        ];
        this.body = {
            'customerId': customerId,
            'accountTypeId': accountTypeId
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Accounts.js